import React,{createContext} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/css/finova-premium.css";
import "./assets/css/user-profile-fix.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AdminLayout from "layouts/Admin.js";
import Home from './pages';
import SigninPage from './pages/signin';
import SignupPage from './pages/signup';
import NotFound from './components/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { SupabaseProvider } from './context/SupabaseContext';

ReactDOM.render(
  <AuthProvider>
    <SupabaseProvider>
      <BrowserRouter>
        <Switch>
          <Route path="/admin" render={(props) => (
            <ProtectedRoute>
              <AdminLayout {...props} />
            </ProtectedRoute>
          )} />
          <Route path='/' component={Home} exact />
          <Route path='/signin' component={SigninPage} exact />
          <Route path='/signup' component={SignupPage} exact />
          <Route component={NotFound} />
          <Redirect from="/" to="/home" />
        </Switch>
      </BrowserRouter>
    </SupabaseProvider>
  </AuthProvider>,
  document.getElementById("root")
);
